export const blogData = [
    {
        title: "Evolution of a Software Engineer",
        subTitle:"How I went from a Tiny Home Builder to Software Engineer",
        img:"https://i.ibb.co/L8r6rsz/portfolio-cap.png",
        tags:["personal"
        ],
        content:["Javascript", "React.js", "JSX", "React Router", "CSS3", "Framer motion", "NoSQL"]

    }
]

